module.exports = {
	"en": {
		"help-tool": {
			"button-text": "Help",
			"support-button": "Get Support",
			"support-page": {
				"create-ticket": {
					"title": "Get support",
					"instructions": "Submit a request below and we will get back to you within 1 business day.",
					"related-content": {
						"title": "These might help solve your issue"
					},
					"fields": {
						"mid": {
							"label": "Select store",
							"validation": "Store required"
						},
						"phoneNumber": {
							"label": "Phone number (optional)"
						},
						"topic": {
							"question": "What is your question related to?",
							"label": "Select a topic",
							"validation": "Topic required",
							"options": {
								"orders": "Orders",
								"settlements": "Settlements",
								"agreements": "Agreements",
								"others": "Others"
							}
						},
						"subject": {
							"label": "Subject",
							"validation": "Subject required"
						},
						"description": {
							"label": "Message",
							"validation": "Description required"
						},
						"attachment": {
							"label": "Add attachments",
							"button": "Upload",
							"info": "Adding screenshots will help us solve the issue faster.",
							"supportedFileTypes": "Supported file types: .png, .jpg, .pdf",
							"error": "Total files size may not exceed {maxSize} MB"
						}
					},
					"submit": "Submit request",
					"service-unavailable-error": "Oops! Something went wrong, try again in a few minutes. If this continues, please {link} for help.",
					"generic-error": "We couldn't process your request. Our systems aren't talking to each other right now. Try refreshing, or come back later. If this continues, please {link} for help.",
					"contact-link": "contact us"
				},
				"view-ticket": {
					"title": "All done!",
					"details": "We've got your request and we'll get you an answer within 1 business day. Here are your details:",
					"ticket": "Request #{ticketId}",
					"email": "Email: {email}",
					"status": "You can track the status in our Support page.",
					"track": "Track status"
				}
			},
			"header": {
				"homeLink": "Reset"
			},
			"home": {
				"greeting": "Hello {givenName}! How can we help you?",
				"topics": "What do you need help with?"
			},
			"topics": {
				"expandButton": "More"
			},
			"feedback": {
				"title": "Was this helpful?",
				"optionYes": "Yes, this was helpful",
				"optionNo": "No, I need more help",
				"positiveFeedback": "Thank you for the positive feedback, this helps us a lot to provide you with more relevant articles in the future."
			},
			"freeTextFeedback": {
				"title": "Help us improve",
				"placeholder": "Why did you not find this content useful?",
				"submitButton": "Send",
				"feedbackMessage": "Thank you for your feedback, this helps us a lot to provide you with more relevant articles in the future."
			},
			"relatedContent": {
				"title": "Related content"
			},
			"search": {
				"buttonLabel": "Search",
				"input": "Search for articles ...",
				"loading": "Loading ...",
				"results": {
					"contact": "Can't find the help you need?",
					"empty": "Sorry, no results were found for your query. Try searching for a different term.",
					"singleTopicFound": "We've found 1 topic",
					"multipleTopicsFound": "We've found {count} topics",
					"singleArticleFound": "We've found 1 article",
					"multipleArticlesFound": "We've found {count} articles"
				}
			},
			"contact": {
				"title": "Contact us",
				"channelsIntro": "Reach out to us so that we can help you.",
				"businessDetailsTitle": "Your business details",
				"businessDetailsName": "Business Name",
				"businessDetailsEmail": "Email",
				"businessDetailsMid": "Merchant ID",
				"phone": {
					"title": "Call us",
					"paragraph": "You can give us a call during business hours on weekdays. If you're located in Sweden or the United Kingdom, you can also call us on the weekend between 10am-4pm."
				},
				"email": {
					"title": "Email us",
					"paragraph": "Shoot us an email and we will get back to you as soon as we can."
				}
			},
			"errorBoundary": {
				"title": "Something went wrong",
				"message": "We are very sorry but there was an error. You can click the 'Go back' button below to go back to the help tool or 'Get Support' button to contact us.",
				"resetButton": "Go back",
				"errorId": "Error ID: {errorId}"
			},
			"tour": {
				"prev": "Previous",
				"next": "Next",
				"done": "Done"
			},
			"notAvailableMobile": {
				"title": "Not Available",
				"buttonBack": "Back",
				"paragraph": "This content is not available on your device. Try opening on a device with a larger screen size such as a desktop computer."
			},
			"shareButton": {
				"title": {
					"article": "Share a deep link to this article",
					"topic": "Share a deep link to this topic",
					"tour": "Share a deep link to this tour"
				},
				"radioItemHome": "Home App",
				"descriptionHome": "Opens help article on Merchant Portal home page",
				"radioItemCurrent": "Current Page",
				"descriptionCurrent": "Opens help article on current page"
			},
			"marketSelector": {
				"whichMarketToContact": "Which market would you like to contact?"
			}
		},
		"orientation": {
			"title": "Learn how to ..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Hello {name}! 👋 I'm your Klarna assistant.",
				"whatDoYouNeedHelpWithPart2": "For many cases, using me will help solve your query in less than 5 minutes.",
				"whatDoYouNeedHelpWithPart3": "What can i help you with today?",
				"selectSupportChannel": "Please select a channel to contact our support service.",
				"selectPayoutIssue": "Perfect! Go ahead and select a payouts related issue 👇",
				"selectOrderIssue": "Perfect! Go ahead and select an orders related issue 👇",
				"capturedOrders": "Do you have any {link1} orders?",
				"capturedOrdersLink1": "captured",
				"notPaidOrder": {
					"isScheduleFollowed": "Is your {link1} (including payout delay) being followed?",
					"isScheduleFollowedLink1": "payout schedule",
					"isHoldbackOrDebt": "If the payout delay has surpassed then please check your {link1}. Is there any holdback or debt due to returns/reversals?",
					"isHoldbackOrDebtLink1": "latest settlement file"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Please verify the capture date of the orders you expected to get paid out and take your payout delay into consideration. You can find your orders {link1}. Are the orders expecting to be paid out captured?",
					"isScheduleFollowedLink1": "here"
				},
				"changePaymentFrequency": "Have you received more than 30 captured orders per month over a 3 month period?",
				"whenWillGetPaid": "The payout date will depend on your payout schedule and the payout delay stated in your contract (T&C). If you're not sure what your payout setup is, you can check it in {link1}. Is the payout schedule (+payout delay) being followed?",
				"whenWillGetPaidLink1": "Settlements",
				"thatHelped": "Thank you for the positive feedback, this helps us a lot to provide you with more relevant help in the future. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Ah I see! Do you have any uncaptured orders?",
					"haveUncapturedOrdersPart2": "If you do not know how to check this, please go to {link1}.",
					"haveUncapturedOrdersPart2Link1": "this page",
					"expirationDateSurpassed": "Has the expiration date surpassed? (usually 28 days)",
					"customerCreditPaymentMethod": "Did the customer choose a credit payment method (invoice, account, direct debit)?",
					"isOrderCaptured": "Is the order {link1}?",
					"isOrderCapturedLink1": "captured"
				}
			},
			"options": {
				"payout": "Payout",
				"orders": "Orders",
				"otherIssue": "Other Issues",
				"whenPaidOrderNext": "When will I get paid next time?",
				"notPaidOrder": "I did not get paid",
				"paidWrongAmount": "I got paid the wrong amount",
				"changeHowOftenPaid": "I want to change how often I get paid",
				"dontKnowHowToCaptureOrder": "I don't know how to capture an order",
				"missedCaptureDeadline": "I missed the capture deadline",
				"needToRefundAnOrder": "I need to refund an order",
				"yes": "Yes",
				"no": "No",
				"partially": "Partially",
				"iNeedMoreHelp": "I need more help",
				"thatHelped": "That helped",
				"contactSupportChannel": "Contact support channels"
			},
			"explanations": {
				"noCapturedOrders": "First things first, you need to {link1}. Once you've captured the order, we'll pay out the amount to your bank account. Fees, returns, and other charges will be deducted from this amount.",
				"noCapturedOrdersLink1": "capture an order",
				"feesReturnsHoldbacks": "Fees, returns, and other charges may be deducted from the payout amount. Please check if you have any holdback or debt due to returns/reversals in the {link1}.",
				"feesReturnsHoldbacksLink1": "latest settlement file",
				"notPaidOrder": {
					"scheduleFollowed": "Once you've captured an order, we'll pay out the amount to your bank account according to your payout schedule. Fees, returns, and other charges will be deducted from this amount. Please check the value of your payout in your {link1}.",
					"scheduleFollowedLink1": "latest settlement file",
					"noHoldback": "Please verify that you have the right bank account details registered for the currency of the payout {link1}.",
					"noHoldbackLink1": "here",
					"withHoldback": "If the value of the captured orders surpasses the debt, please verify that you have the right bank account details registered for the currency of the payout {link1}.",
					"withHoldbackLink1": "here"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "You will receive the next payout according to the payout schedule + payout delay."
				},
				"changePaymentFrequency": {
					"isAble": "Please proceed by contacting our support through the channels below.",
					"isUnable": "Unfortunately you do not meet the requirements to change your payout schedule."
				},
				"orders": {
					"uncapturedDynamicYes": "Oh I see you have {number} uncaptured orders.",
					"uncapturedDynamicNo": "I can see you don't have uncaptured orders",
					"uncapturedYesPart1": "Time for you to capture some orders then! To do so,",
					"uncapturedYesPart2": "1. Go to the Orders Page {link1}.",
					"uncapturesYesPart2Link1": "by clicking here",
					"uncapturedYesPart3": "2. Click on the Klarna reference of the order you wish to capture",
					"uncapturedYesPart4": "3. Choose the articles or add an amount you want to capture",
					"uncapturedYesPart5": "4. Press “Capture”",
					"uncapturedNoPart1": "To capture an order you must first have orders to capture.",
					"uncapturedNoPart2": "When capturing an order it means to confirm that the order has been shipped to the customer. This should always be done on the same day that the order is shipped on every order. When you capture an order you also let us know that we should trigger a payout to you for that order. Read more about how to capture an order {link1}.",
					"uncapturedNoLink1": "here",
					"customerCreditPaymentMethodNo": "Unfortunately, we can not extend an order that has expired. You will have to recreate the order.",
					"expirationDateSurpassedYes": "Let us help you extend the order, please contact our support through one of the below channels.",
					"expirationDateSurpassedNo": "Go to {link1}. Select the order by checking the box next to the Klarna reference number. Click on Extend expiry date and confirm your request.",
					"expirationDateSurpassedNoLink1": "Orders > To capture",
					"isOrderCapturedYesPart1": "Select the items you want to refund and click on Refund. You can also click on Refund first and input the amount you wish to refund - choose which way works best for you.",
					"isOrderCapturedYesPart2": "Your customer will receive a repayment of the amount they already paid within 2-5 business days. And you'll see this amount deducted from your next payout.",
					"isOrderCapturedNo": "If you have an uncaptured order that you won't ship, you can {link1} the whole order. Go to the {link2} and click on Cancel order.",
					"isOrderCapturedNoLink1": "cancel",
					"isOrderCapturedNoLink2": "order page",
					"refundPartiallyCaptured": "If you partially captured the order for items you shipped and won't fullfil the rest, you should release the uncaptured part of the order. Go to the {link1}, click on More actions and select Release.",
					"refundPartiallyCapturedLink1": "order page"
				}
			},
			"messages": {
				"sorryToHearThat": "Sorry to hear that I wasn't helpful. You will shortly be redirected to contact our support."
			},
			"button": {
				"label": "Get Support"
			},
			"contact": {
				"chat": "Chat with an agent",
				"ticket": "Submit a ticket",
				"times": {
					"minutes": "Waiting time: {time} minute(s)",
					"hours": "Waiting time: {time} hour(s)",
					"days": "Waiting time: {time} day(s)"
				}
			}
		}
	}
};